module.exports = __webpack_public_path__ + "static/media/undraw_hello.b863901f.svg";